import axios from './index';

import type { ApiResponse } from './dramas';

export interface CommentUser {
    id?: string;
    nickname?: string | null;
    avatar_url?: string | null;
    email?: string | null;
    wallet_address?: string | null;
    status?: number;
    [property: string]: unknown;
}

export interface CommentDrama {
    id?: string;
    title?: string | null;
    cover_url?: string | null;
    status?: string | null;
    user_id?: string | null;
    [property: string]: unknown;
}

export interface CommentEpisode {
    id?: string;
    drama_id?: string | null;
    type?: string | null;
    episode_no?: string | number | null;
    title?: string | null;
    video_url?: string | null;
    hls_url?: string | null;
    description?: string | null;
    cover_url?: string | null;
    duration_sec?: string | number | null;
    drama?: CommentDrama | null;
    [property: string]: unknown;
}

/** 真实列表字段（OpenAPI data 未细化） */
export interface CommentItem {
    id: string;
    work_id?: string;
    work_user_id?: string;
    item_type?: 'EPISODE' | 'SHORT_VIDEO' | string;
    user_id?: string;
    content?: string | null;
    ip_region?: string | null;
    parent_id?: string | null;
    root_id?: string | null;
    reply_to_user_id?: string | null;
    like_count?: number | string | null;
    reply_count?: number | string | null;
    featured_reply_id?: string | null;
    is_first_comment?: boolean | string | null;
    author_liked?: boolean | null;
    author_replied?: boolean | null;
    sort_score?: string | number | null;
    audit_status?: 'APPROVED' | 'PENDING' | string;
    created_at?: string | number | null;
    updated_at?: string | number | null;
    deleted_at?: string | number | null;
    deleted_by?: string | null;
    deleted_reason?: string | null;
    is_root?: 0 | 1 | boolean | string | null;
    user?: CommentUser | null;
    work_user?: CommentUser | null;
    reply_to_user?: CommentUser | null;
    deleted_by_user?: CommentUser | null;
    episode?: CommentEpisode | null;
    drama?: CommentDrama | null;
    [property: string]: unknown;
}

export type CommentListParams = {
    page?: number;
    size?: number;
    id?: string;
    work_id?: string;
    work_user_id?: string;
    item_type?: 'EPISODE' | 'SHORT_VIDEO';
    user_id?: string;
    content?: string;
    parent_id?: string;
    root_id?: string;
    audit_status?: 'APPROVED' | 'PENDING';
    is_first_comment?: 'true' | 'false';
    is_root?: 0 | 1;
    'created_at[]'?: string[];
    'updated_at[]'?: string[];
    'deleted_at[]'?: string[];
};

export type CommentDeleteBody = {
    reason?: string;
};

/** 真实审计日志字段（接口 data 为 { status, body, headers } 包装） */
export interface CommentAuditLog {
    logId?: string;
    operatorId?: string | null;
    action?: string | null;
    reason?: string | null;
    createdAt?: string | number | null;
    /** 兼容旧/未对齐字段 */
    id?: string;
    operator_id?: string | null;
    created_at?: string | number | null;
    [property: string]: unknown;
}

export type CommentAuditLogsPayload =
    | CommentAuditLog[]
    | {
          status?: number;
          body?: CommentAuditLog[];
          headers?: Record<string, unknown>;
      }
    | null
    | undefined;

export const normalizeCommentAuditLogs = (data: CommentAuditLogsPayload): CommentAuditLog[] => {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.body)) return data.body;
    return [];
};

export const commentList = (params?: CommentListParams, config?: { signal?: AbortSignal }) =>
    axios<ApiResponse<CommentItem[]>>('/v1/comments', {
        method: 'get',
        params,
        signal: config?.signal,
    });

/** 软删除：body 必传 object；操作人由 Bearer 识别，不再传 operatorId */
export const commentDelete = (commentId: string, body: CommentDeleteBody = {}) =>
    axios<ApiResponse>(`/v1/comments/${commentId}`, {
        method: 'delete',
        data: body,
    });

/** 评论操作历史 */
export const commentAuditLogs = (commentId: string) =>
    axios<ApiResponse<CommentAuditLogsPayload>>(`/v1/comments/${commentId}/audit-logs`, {
        method: 'get',
    });

/** 导出（若后端尚未提供该路由会失败，由页面提示） */
export const commentExport = (params?: CommentListParams) =>
    axios<ApiResponse>('/v1/comments/export', {
        method: 'get',
        params,
    });

export type { ApiResponse };
